/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: http 入口
 */

import http, { IProps } from './http'
import { ICommonResponse } from '../index'


/**
 * XHR 请求接口定义
 * @param  {String} options.method  请求方法（默认为 get）
 * @param  {String} options.url     请求路径
 * @param  {Object} options.params  请求体
 * @return {Promise}
 * API 封装格式为 {}
 */

export interface xhr {
    (option: IProps): Promise<ICommonResponse>
}

const xhr: xhr = http

export default xhr
